import { ComboboxPopover as BaseComboboxPopover } from '@reach/combobox'

import { styled } from '~/styled'

export const ComboboxPopover = styled(BaseComboboxPopover, {
  base: [
    'bg-white',
    'border',
    'border-grey-200',
    'rounded-md',
    'shadow-md',
    'box-border',
    'font-body',
    'text-md',
    'outline-none',
    'p-1',
    'translate-y-2'
  ]
})
